export const initialCategoryState = {
  categories: [],
  category: null,
  status: 'idle',
  error: { message: null }, // Error as an object for consistency
};
